import { createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../constants/apiRoutes";
import { invoicesAPI } from "../../../constants/reduxConstant";
import { getAuthorization } from "../../../services/config";
import { updateLoading } from "../loader";
import rollbar from "../../../rollbarConfig";

const { get_invoices = "", invoice_download = "" } = invoicesAPI;
const { V1: { GET_SELLER_INVOICES, DOWNLOAD_SELLER_INVOICES } = {} } = API_ROUTES;

const fetchInvoices = createAsyncThunk(
  get_invoices,
  async (querry, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {

      const response = await API.get(GET_SELLER_INVOICES + querry);
    
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } 
  }
);
const fetchDownloadInvoices = createAsyncThunk(
  invoice_download,
  async (id, { dispatch, getState }) => {
    const API = getAuthorization(getState, dispatch, { isAuthHeader: true });
    try {
      dispatch(updateLoading(true));
      const url = DOWNLOAD_SELLER_INVOICES.replace(':id', id);
      const response = await API.get(url);
      return response?.data;
    } catch (err) {
      rollbar.error("Error message", err);
      return err;
    } finally {
      dispatch(updateLoading(false));
    } 
  }
);

export { fetchInvoices, fetchDownloadInvoices };
